<template>
  <div
    :class="$style.base"
    @click="showCreateNoteModal = true"
  >
    <CreateNote
      v-if="showCreateNoteModal"
      :currentNote="order.note || undefined"
      @submit="order.note = $event"
      @close="showCreateNoteModal = false"
    />

    <BaseCard
      v-if="order.note"
      v-test="'register-order-note-item'"
      noPadding
    >
      <div :class="$style.note">
        <BaseText
          :maxLines="2"
          v-test="'register-order-note'"
        >
          <span v-html="filters.formatEnters(order.note)" />
        </BaseText>
        <BaseIcon name="edit" />
      </div>
    </BaseCard>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { ref } from 'vue';
import filters from '@/filters';
import CreateNote from '@/modals/CreateNote.vue';
import { useRegisterOrderStore } from '@/modules/register/stores/order';

const { order } = useRegisterOrderStore();
const showCreateNoteModal = ref(false);
</script>

<style
  lang="scss"
  module
>
.note {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: $spacing * 0.5;
  padding: $spacing * 0.5;
  cursor: pointer;
}
</style>
